import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledListItemProps } from './LogoShowcase.types';

export const StyledImage = styled.img`
  display: block;
  width: auto;
  height: 100%;
`;

export const StyledWrapper = styled.div`
  background: ${({ theme }) => theme.colors.gradients.alternate};
  width: 100%;
`;

export const StyledList = styled.ul`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: column;
    padding: ${rem('56px')} ${({ theme }) => rem(theme.spacings.m)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: ${rem('120px')} 0;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`;

export const StyledListItem = styled.li<IStyledListItemProps>`
  list-style: none;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: 100%;
    height: ${({ imageHeight }) => rem(imageHeight.sm)};
    margin: ${({ theme }) => rem(theme.spacings.m)} 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: calc(100% / ${({ length }) => length});
    height: ${({ imageHeight }) => rem(imageHeight.lg)};
    ${({ boxed }) => !boxed && `margin: 0 ${rem('32px')};`}
  }
`;
